<script setup lang="ts">
import { formatNumber } from '../../utils/format'
import { FILE_ATTENTION_CHIPS, type FileAttention } from '../../utils/file-attention'
import type { UserFileStatusCountsResponse } from '@roadfootage/api-client'

defineProps<{
  modelValue: FileAttention
  /** Null until loaded, or when loading failed: the chips then show no number. */
  counts: UserFileStatusCountsResponse | null
}>()

defineEmits<{ 'update:modelValue': [value: FileAttention] }>()
</script>

<template>
  <div class="row q-gutter-sm items-center" role="group" aria-label="Quick filters">
    <q-chip
      v-for="chip in FILE_ATTENTION_CHIPS"
      :key="chip.value ?? 'all'"
      clickable
      :outline="modelValue !== chip.value"
      :color="modelValue === chip.value ? 'primary' : undefined"
      :text-color="modelValue === chip.value ? 'white' : undefined"
      :aria-pressed="modelValue === chip.value"
      :data-testid="`attention-chip-${chip.value ?? 'All'}`"
      @click="$emit('update:modelValue', chip.value)"
    >
      {{ chip.label }}
      <span v-if="counts" class="q-ml-xs text-weight-bold">{{
        formatNumber(chip.count(counts))
      }}</span>
    </q-chip>
  </div>
</template>
